<div *ngIf="isLoadingBiblia; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>
  <div class="divHome">
    <!-- 1. PAGE HERO CANÓNICO -->
    <div class="page-hero">
      <div class="page-hero-content">
        <div class="page-hero-eyebrow">
          <mat-icon class="hero-eyebrow-icon">hub</mat-icon>
          <span>OPERACIONES</span>
        </div>
        <h1 class="page-hero-title">BIBLIA DE OPERACIONES</h1>
        <p class="page-hero-subtitle">
          Monitoreo integral, asignación y trazabilidad de actividades
          operativas y pasajeros.
        </p>
      </div>

      <div class="page-hero-actions">
        <div class="stat-card">
          <span class="stat-label">Total Actividades</span>
          <strong class="stat-value">{{ totalActivitiesCount }}</strong>
        </div>

        <div
          class="stat-card"
          [class.stat-card--muted]="!activeFilterChips.length"
        >
          <span class="stat-label">Filtros Activos</span>
          <strong class="stat-value">{{ activeFilterChips.length }}</strong>
        </div>

        <div class="stat-card" [class.stat-card--alert]="pendingAcCount > 0">
          <span class="stat-label">Pendientes A.C.</span>
          <strong class="stat-value">{{ pendingAcCount }}</strong>
        </div>

        <button
          type="button"
          mat-flat-button
          class="btn-hero-cta"
          [disabled]="isLoadingBiblia"
          (click)="refreshBiblia()"
        >
          <mat-icon>refresh</mat-icon>
          <span>Actualizar</span>
        </button>
      </div>
    </div>

    <!-- 2. FILTERS CARD UNIFICADA -->
    <div class="filters-card">
      <!-- Cabecera de Filtros -->
      <div class="filters-header">
        <div class="filters-heading">
          <div class="filters-title">
            <mat-icon class="filters-title-icon">tune</mat-icon>
            <span>Filtros</span>
            <span class="filters-count" *ngIf="activeFilterChips.length">{{
              activeFilterChips.length
            }}</span>
          </div>
          <p class="filters-subtitle">
            Busca y organiza las actividades, pasajeros y servicios programados.
          </p>
        </div>

        <button
          *ngIf="hasActiveFilters"
          type="button"
          mat-stroked-button
          class="btn-clear-all"
          (click)="clearAllFilters()"
        >
          <mat-icon>filter_alt_off</mat-icon>
          Limpiar filtros
        </button>
      </div>

      <!-- Atajos Operativos A.C. -->
      <div class="presets-row">
        <span class="presets-label">Consultas rápidas:</span>
        <div class="presets-list">
          <button
            type="button"
            class="preset-btn"
            [class.active]="activePreset === 'today'"
            (click)="togglePreset('today')"
          >
            <mat-icon>today</mat-icon>
            <span>Hoy</span>
          </button>

          <button
            type="button"
            class="preset-btn"
            [class.active]="activePreset === 'next3days'"
            (click)="togglePreset('next3days')"
          >
            <mat-icon>date_range</mat-icon>
            <span>Próximos 3 días</span>
          </button>

          <button
            type="button"
            class="preset-btn"
            [class.active]="activePreset === 'pendingAC'"
            (click)="togglePreset('pendingAC')"
          >
            <mat-icon>assignment_late</mat-icon>
            <span>Pendiente A.C.</span>
          </button>

          <button
            type="button"
            class="preset-btn"
            [class.active]="activePreset === 'minors'"
            (click)="togglePreset('minors')"
          >
            <mat-icon>family_restroom</mat-icon>
            <span>Con Menores</span>
          </button>
        </div>
      </div>

      <!-- FILA 1: BÚSQUEDAS (Cargar del Sistema + Buscar en Pantalla) -->
      <div class="filters-search-row">
        <!-- Cluster Carga en Sistema (Naranja Explorandes) -->
        <div class="filter-cluster filter-cluster--fetch">
          <div class="cluster-header">
            <span class="cluster-tag cluster-tag--fetch">
              <mat-icon class="cluster-icon">travel_explore</mat-icon>
              <span>Buscar en todo el sistema</span>
            </span>
            <span class="cluster-loading" *ngIf="loading">
              <mat-spinner diameter="13"></mat-spinner>
              <span>Buscando...</span>
            </span>
            <span class="cluster-hint" *ngIf="!loading">
              Fechas anteriores o futuras
            </span>
          </div>

          <div class="cluster-fields">
            <!-- Fecha Actividad -->
            <div class="filter-cell filter-cell--date">
              <mat-form-field
                appearance="outline"
                class="filter-field filter-field--fetch"
              >
                <mat-label>Fecha de Actividad</mat-label>
                <mat-icon matPrefix class="field-prefix-icon">event</mat-icon>
                <mat-date-range-input [rangePicker]="rangePickerActivity">
                  <input
                    matStartDate
                    placeholder="Desde"
                    [(ngModel)]="startDateActivity"
                    (keydown.enter)="onActivityDateFilterApply()"
                  />
                  <input
                    matEndDate
                    placeholder="Hasta"
                    [(ngModel)]="endDateActivity"
                    (keydown.enter)="onActivityDateFilterApply()"
                  />
                </mat-date-range-input>
                <button
                  *ngIf="startDateActivity || endDateActivity"
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="field-clear-suffix"
                  aria-label="Limpiar fecha"
                  (click)="cleanDateSelectedActivity()"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="rangePickerActivity"
                ></mat-datepicker-toggle>
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="btn-fetch-trigger"
                  matTooltip="Buscar actividades en este rango de fechas"
                  (click)="onActivityDateFilterApply()"
                  [disabled]="loading"
                >
                  <mat-icon>search</mat-icon>
                </button>
                <mat-date-range-picker #rangePickerActivity>
                  <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>
                      Cancelar
                    </button>
                    <button
                      mat-raised-button
                      class="btn-picker-apply"
                      (click)="onActivityDateFilterApply()"
                      matDateRangePickerApply
                    >
                      Aplicar fechas
                    </button>
                    <button
                      mat-button
                      matDateRangePickerCancel
                      (click)="cleanDateSelectedActivity()"
                    >
                      Limpiar
                    </button>
                  </mat-date-range-picker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            </div>

            <!-- Nro. de File -->
            <div class="filter-cell filter-cell--file">
              <mat-form-field
                appearance="outline"
                class="filter-field filter-field--fetch"
              >
                <mat-label>Número de File</mat-label>
                <mat-icon matPrefix class="field-prefix-icon">tag</mat-icon>
                <input
                  type="text"
                  placeholder="Ej. 24-0012..."
                  matInput
                  [formControl]="fileControl"
                  [matAutocomplete]="autoFile"
                  (keydown.enter)="onFileFilterEnter()"
                />
                <button
                  *ngIf="fileControl.value"
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="field-clear-suffix"
                  aria-label="Limpiar file"
                  (click)="removeFilterChip('file')"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="btn-fetch-trigger"
                  matTooltip="Buscar este file"
                  (click)="onFileFilterEnter()"
                  [disabled]="loading"
                >
                  <mat-icon>search</mat-icon>
                </button>
                <mat-autocomplete
                  #autoFile="matAutocomplete"
                  [displayWith]="getOptionText"
                  (optionSelected)="onFileSelected($event.option.value)"
                >
                  <mat-option value="{{ null }}">No seleccionar</mat-option>
                  <mat-option
                    *ngFor="let file of filteredFiles$ | async"
                    [value]="file"
                  >
                    {{ file }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Cluster Búsqueda en Pantalla (Neutro) -->
        <div class="filter-cluster filter-cluster--local">
          <div class="cluster-header">
            <span class="cluster-tag cluster-tag--local">
              <mat-icon class="cluster-icon">search</mat-icon>
              <span>Buscar en pantalla</span>
            </span>
            <span class="cluster-hint">Filtra texto en la lista actual</span>
          </div>

          <div class="cluster-fields">
            <div class="filter-cell filter-cell--omni">
              <mat-form-field appearance="outline" class="filter-field">
                <mat-label>Buscador rápido</mat-label>
                <mat-icon matPrefix class="field-prefix-icon">search</mat-icon>
                <input
                  matInput
                  type="text"
                  autocomplete="off"
                  placeholder="Pasajero, guía, hotel, transporte..."
                  [(ngModel)]="searchValue"
                  (ngModelChange)="onSearchChange($event)"
                />
                <button
                  *ngIf="searchValue"
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="field-clear-suffix"
                  aria-label="Limpiar búsqueda"
                  (click)="onSearchChange('')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- FILA 2: FILTROS DE LISTA (5 desplegables en cuadrícula equilibrada) -->
      <div class="filters-dropdowns-row">
        <!-- Nombre de File -->
        <div class="filter-cell filter-cell--dropdown">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Nombre de File</mat-label>
            <mat-icon matPrefix class="field-prefix-icon">description</mat-icon>
            <input
              type="text"
              matInput
              [formControl]="nombreFileControl"
              [matAutocomplete]="autoNombre"
            />
            <button
              *ngIf="nombreFileControl.value"
              mat-icon-button
              matSuffix
              type="button"
              class="field-clear-suffix"
              aria-label="Limpiar nombre file"
              (click)="removeFilterChip('nombreFile')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete
              #autoNombre="matAutocomplete"
              (optionSelected)="onNombreFileSelected($event.option.value)"
            >
              <mat-option value="{{ null }}">Todos los nombres</mat-option>
              <mat-option
                *ngFor="let service of filteredNombreFiles$ | async"
                [value]="service"
              >
                {{ service }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- Destinos (Multi-select) -->
        <div class="filter-cell filter-cell--dropdown">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Destino</mat-label>
            <mat-icon matPrefix class="field-prefix-icon">place</mat-icon>
            <mat-select
              [formControl]="selectDestino"
              (selectionChange)="applyFilterSelect()"
              multiple
            >
              <mat-option
                *ngFor="let destino of arrayDestino"
                [value]="destino"
              >
                {{ destino }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Status -->
        <div class="filter-cell filter-cell--dropdown">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Estado de File</mat-label>
            <mat-icon matPrefix class="field-prefix-icon">flag</mat-icon>
            <input
              type="text"
              matInput
              [formControl]="statusControl"
              [matAutocomplete]="autoStatus"
            />
            <button
              *ngIf="statusControl.value"
              mat-icon-button
              matSuffix
              type="button"
              class="field-clear-suffix"
              aria-label="Limpiar status"
              (click)="removeFilterChip('status')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete
              #autoStatus="matAutocomplete"
              (optionSelected)="onStatusSelected($event.option.value)"
            >
              <mat-option value="{{ null }}">Todos los estados</mat-option>
              <mat-option
                *ngFor="let status of filteredStatus$ | async"
                [value]="status"
              >
                {{ status }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- Revisión A.C. -->
        <div class="filter-cell filter-cell--dropdown">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Revisión A.C.</mat-label>
            <mat-icon matPrefix class="field-prefix-icon">verified</mat-icon>
            <input
              type="text"
              matInput
              [formControl]="reviewControl"
              [matAutocomplete]="autoReview"
            />
            <button
              *ngIf="reviewControl.value"
              mat-icon-button
              matSuffix
              type="button"
              class="field-clear-suffix"
              aria-label="Limpiar revisión"
              (click)="removeFilterChip('review')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete
              #autoReview="matAutocomplete"
              (optionSelected)="onReviewSelected($event.option.value)"
            >
              <mat-option value="{{ null }}">Todas las revisiones</mat-option>
              <mat-option
                *ngFor="let review of filteredReviewAC$ | async"
                [value]="review"
              >
                {{ review }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- Tipo de Salida -->
        <div class="filter-cell filter-cell--dropdown">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Tipo de Salida</mat-label>
            <mat-icon matPrefix class="field-prefix-icon">alt_route</mat-icon>
            <input
              type="text"
              matInput
              [formControl]="tipoSalidaControl"
              [matAutocomplete]="autoTipoSalida"
            />
            <button
              *ngIf="tipoSalidaControl.value"
              mat-icon-button
              matSuffix
              type="button"
              class="field-clear-suffix"
              aria-label="Limpiar tipo de salida"
              (click)="removeFilterChip('tipoSalida')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete
              #autoTipoSalida="matAutocomplete"
              (optionSelected)="onTipoSalidaSelected($event.option.value)"
            >
              <mat-option value="{{ null }}">Todos los tipos</mat-option>
              <mat-option
                *ngFor="let salida of filteredTipoSalida$ | async"
                [value]="salida"
              >
                {{ salida }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      <!-- Barra de progreso discreta durante la búsqueda (Naranja Explorandes) -->
      <mat-progress-bar
        *ngIf="loading"
        mode="indeterminate"
        class="fetch-progress-bar"
      ></mat-progress-bar>

      <!-- Micro-helper de orientación operativa -->
      <div class="filters-hint-micro">
        <mat-icon class="hint-icon">info</mat-icon>
        <span>
          Estás viendo las actividades de los
          <strong>últimos 2 meses y el próximo mes</strong>. Para ver
          operaciones anteriores o futuras, usa la
          <strong>Búsqueda en todo el sistema</strong>.
        </span>
      </div>

      <!-- Footer de Chips de Filtros Activos -->
      <div class="filters-footer">
        <div
          class="active-filters-row"
          [class.empty]="!activeFilterChips.length"
        >
          <ng-container *ngIf="activeFilterChips.length; else noActiveFilters">
            <span class="active-filters-label">Activos:</span>
            <div class="active-filters-chips">
              <span
                class="filter-chip"
                [class.filter-chip--fetch]="chip.isDb"
                *ngFor="let chip of activeFilterChips; trackBy: trackByChip"
              >
                <mat-icon *ngIf="chip.isDb" class="chip-fetch-icon"
                  >travel_explore</mat-icon
                >
                <span class="filter-chip-text">{{ chip.label }}</span>
                <button
                  type="button"
                  class="filter-chip-remove"
                  (click)="removeFilterChip(chip.id)"
                  [attr.aria-label]="'Quitar filtro ' + chip.label"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </span>
            </div>
          </ng-container>
          <ng-template #noActiveFilters>
            <span class="active-filters-placeholder">Sin filtros activos</span>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- 3. LEYENDA CANÓNICA COLAPSABLE -->
    <div class="legend-card">
      <div class="legend-summary" (click)="toggleLegend()">
        <div class="legend-summary-left">
          <div class="legend-icon-shell">
            <mat-icon>info</mat-icon>
          </div>
          <div class="legend-summary-text">
            <span class="legend-eyebrow">GUÍA RÁPIDA</span>
            <h3 class="legend-title">Simbología, Estados y Pasajeros</h3>
            <p class="legend-desc">
              Referencia visual de códigos de color y marcadores de estado.
            </p>
          </div>
        </div>

        <button
          type="button"
          mat-stroked-button
          class="legend-toggle-btn"
          (click)="$event.stopPropagation(); toggleLegend()"
        >
          <mat-icon>{{
            isLegendExpanded ? "expand_less" : "expand_more"
          }}</mat-icon>
          <span>{{ isLegendExpanded ? "Ocultar guía" : "Ver guía" }}</span>
        </button>
      </div>

      <div class="legend-content" *ngIf="isLegendExpanded">
        <div class="legend-grid">
          <!-- Col 1: Estados de File (Estilo idéntico a columna Status) -->
          <div class="legend-section">
            <h4 class="legend-section-title">Estados de File</h4>
            <div class="legend-items">
              <div class="legend-item">
                <span class="fileDisplayState-pill fileDisplayState-Nuevo"
                  >NUEVO PEDIDO</span
                >
                <span class="legend-label">Recién ingresado</span>
              </div>
              <div class="legend-item">
                <span class="fileDisplayState-pill fileDisplayState-Proceso"
                  >EN PROCESO</span
                >
                <span class="legend-label">En coordinación</span>
              </div>
              <div class="legend-item">
                <span class="fileDisplayState-pill fileDisplayState-Confirmado"
                  >CONFIRMADO</span
                >
                <span class="legend-label">Servicios confirmados</span>
              </div>
              <div class="legend-item">
                <span
                  class="fileDisplayState-pill fileDisplayState-Reconfirmado"
                  >RECONFIRMADO</span
                >
                <span class="legend-label">Listo para operación</span>
              </div>
            </div>
          </div>

          <!-- Col 2: Pasajeros (PAX) -->
          <div class="legend-section">
            <h4 class="legend-section-title">Pasajeros (PAX)</h4>
            <div class="legend-items">
              <div class="legend-item">
                <div
                  class="legend-icon-badge"
                  style="
                    color: #e95a1a;
                    background: #fff5f0;
                    border-color: #fed7aa;
                  "
                >
                  <mat-icon>groups_2</mat-icon>
                </div>
                <span class="legend-label">Sin menores de edad</span>
              </div>
              <div class="legend-item">
                <div
                  class="legend-icon-badge"
                  style="
                    color: #0284c7;
                    background: #f0f9ff;
                    border-color: #bae6fd;
                  "
                >
                  <mat-icon>groups_2</mat-icon>
                </div>
                <span class="legend-label">Con menores de edad (&lt;18)</span>
              </div>
              <div class="legend-item">
                <div
                  class="legend-icon-badge"
                  style="
                    color: #16a34a;
                    background: #f0fdf4;
                    border-color: #bbf7d0;
                  "
                >
                  <mat-icon>person</mat-icon>
                </div>
                <span class="legend-label">Revisión A.C. aprobada</span>
              </div>
              <div class="legend-item">
                <div
                  class="legend-icon-badge"
                  style="
                    color: #eab308;
                    background: #fefce8;
                    border-color: #fef08a;
                  "
                >
                  <mat-icon>person</mat-icon>
                </div>
                <span class="legend-label">Revisión A.C. pendiente</span>
              </div>
            </div>
          </div>

          <!-- Col 3: Tipos de Salida -->
          <div class="legend-section">
            <h4 class="legend-section-title">Tipos de Salida</h4>
            <div class="legend-items">
              <div class="legend-item">
                <span class="legend-badge salida-privado">Privado</span>
                <span class="legend-label">Servicio exclusivo</span>
              </div>
              <div class="legend-item">
                <span class="legend-badge salida-fija">Salida Fija</span>
                <span class="legend-label">Salida compartida / SSFF</span>
              </div>
              <div class="legend-item">
                <span class="legend-badge salida-serie">Serie</span>
                <span class="legend-label">Itinerario en serie</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 4. TOOLBAR CANÓNICA -->
    <div class="table-toolbar">
      <div class="table-toolbar-count">
        <mat-icon class="table-toolbar-icon">table_rows</mat-icon>
        <span
          >{{ totalItems }} actividades encontradas ({{
            cantFiles
          }}
          files)</span
        >
      </div>
      <div class="table-toolbar-help">
        Vista calibrada a 10 filas fijas con scroll vertical
      </div>
    </div>

    <div class="divTable">
      <div
        class="mat-elevation-z8"
        *ngIf="bibliaDataSource && !isLoadingBiblia && userName"
      >
        <mat-table
          #bibliaTable
          [dataSource]="bibliaDataSource"
          matSort
          [trackBy]="trackByActivityId"
          matTableExporter
          #exporter="matTableExporter"
        >
          <ng-container matColumnDef="dateFile">
            <mat-header-cell
              *matHeaderCellDef
              class="headerStyleSmall sticky-header"
            >
              <button mat-icon-button (click)="toggleAllRows()">
                <mat-icon>{{
                  allExpanded ? "expand_less" : "expand_more"
                }}</mat-icon>
              </button>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleSmall sticky-cell"
            >
              <button mat-icon-button (click)="toggleRow(bibliaActivityRow)">
                <mat-icon>{{
                  bibliaActivityRow.expanded ? "expand_less" : "expand_more"
                }}</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="day">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              Day
            </mat-header-cell>
            <mat-cell *matCellDef="let bibliaActivityRow" class="bodyStyle">
              {{ bibliaActivityRow.day }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="date">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyleMedium sticky-header-two"
              >Fecha de Actividad</mat-header-cell
            >
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium sticky-cell-two"
            >
              {{ bibliaActivityRow.date }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="horaProgramada">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyleMedium"
              >Hora Programada</mat-header-cell
            >
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              {{ bibliaActivityRow?.horaProgramada || "-" }}
              <mat-icon
                class="icon-color icon-edit"
                (click)="openTimePickerDialog(bibliaActivityRow)"
                >edit</mat-icon
              >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="vuelos">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Vuelos
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div
                *ngIf="
                  bibliaActivityRow.vuelos?.length &&
                    isFlightVisibleValidate(bibliaActivityRow);
                  else withoutFlights
                "
              >
                <ng-container
                  *ngIf="
                    bibliaActivityRow.expanded && bibliaActivityRow.vuelos;
                    else availableFlights
                  "
                >
                  <div class="divPassenger">
                    <div *ngFor="let vuelo of bibliaActivityRow.vuelos">
                      <p
                        *ngIf="isFlightVisible(bibliaActivityRow, vuelo)"
                        [class.explorandes-flight]="!!vuelo.isExplorandesFlight"
                        [class.non-explorandes-flight]="
                          !vuelo.isExplorandesFlight
                        "
                      >
                        <strong>{{ vuelo.airline }} - </strong>
                        <strong>{{ vuelo.flightNumber }} - </strong>
                        <strong
                          >{{ vuelo.flightCode ? vuelo.flightCode : "N/A" }} -
                        </strong>
                        <strong
                          >{{
                            vuelo.flightDate
                              ? (vuelo?.flightDate | date: "dd/MM/yyyy")
                              : "N/A"
                          }}
                        </strong>
                        <br />
                        Despegue: {{ formatHoraVuelo(vuelo.departureTime) }}
                        <br />
                        Arrivo: {{ formatHoraVuelo(vuelo.arrivalTime) }}
                      </p>
                    </div>
                  </div>
                </ng-container>

                <ng-template #availableFlights>
                  <div>SI +</div>
                </ng-template>
              </div>

              <ng-template #withoutFlights>
                <div>NO</div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="trenes">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Trenes
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div
                *ngIf="
                  bibliaActivityRow.serviciosMedio?.length;
                  else withoutTrains
                "
              >
                <ng-container
                  *ngIf="
                    bibliaActivityRow.expanded &&
                      bibliaActivityRow.serviciosMedio;
                    else availableTrains
                  "
                >
                  <div class="divPassenger">
                    <i-tabler
                      *ngIf="
                        bibliaActivityRow.upgradeServiceTypes?.includes(
                          'TICKET'
                        )
                      "
                      name="diamond"
                      class="diamond-upgrade"
                    ></i-tabler>
                    <p
                      *ngFor="let servicio of bibliaActivityRow.serviciosMedio"
                    >
                      <strong>{{ servicio.circuitoTren || "N/A" }} - </strong>
                      <strong
                        >{{ servicio.varianteFrecuencia || "N/A" }} -
                      </strong>
                      <br />
                      {{ convertirHora12Horas(servicio.horario) || "N/A" }}
                    </p>
                  </div>
                </ng-container>

                <ng-template #availableTrains>
                  <div>
                    <i-tabler
                      *ngIf="
                        bibliaActivityRow.upgradeServiceTypes?.includes(
                          'TICKET'
                        )
                      "
                      name="diamond"
                      class="diamond-upgrade"
                    ></i-tabler>
                    SI +
                  </div>
                </ng-template>
              </div>

              <ng-template #withoutTrains>
                <div>NO</div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="tipoTarifaAlojamiento">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Tipo Habitación
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div
                *ngIf="
                  bibliaActivityRow.serviciosAlojamiento?.length;
                  else withoutAccommodation
                "
              >
                <ng-container
                  *ngIf="
                    bibliaActivityRow.expanded &&
                      bibliaActivityRow.serviciosAlojamiento;
                    else availableAccommodation
                  "
                >
                  <div class="divPassenger">
                    <p
                      *ngFor="
                        let accommodationService of bibliaActivityRow.serviciosAlojamiento
                      "
                    >
                      <strong
                        >{{ accommodationService.paxAlojamiento }} -
                        {{ accommodationService.tipoTarifaAlojamiento }}</strong
                      >
                    </p>
                  </div>
                </ng-container>

                <ng-template #availableAccommodation>
                  <div>SI +</div>
                </ng-template>
              </div>

              <ng-template #withoutAccommodation>
                <div>NO</div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="fileNumber">
            <mat-header-cell *matHeaderCellDef class="headerStyle">
              File
            </mat-header-cell>
            <mat-cell *matCellDef="let bibliaActivityRow" class="bodyStyle">
              <div>
                <div>
                  {{ bibliaActivityRow.fileNumber
                  }}{{ bibliaActivityRow.fileExtend ?? "" }}
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="equipos">
            <mat-header-cell *matHeaderCellDef class="headerStyle">
              Equipos
            </mat-header-cell>
            <mat-cell *matCellDef="let bibliaActivityRow" class="bodyStyle">
              <ng-container
                *ngIf="bibliaActivityRow.equipo?.length > 0; else NOOBS"
              >
                <div *ngIf="!bibliaActivityRow.expanded">
                  <div>SI +</div>
                </div>

                <div *ngIf="bibliaActivityRow.expanded">
                  <div class="divPassenger">
                    <span>Equipos:</span>
                    <div *ngFor="let item of bibliaActivityRow.equipo">
                      * {{ item }}
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #NOOBS>
                <div>
                  <div>NO</div>
                </div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="tipoSalida">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Tipo Salida
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div
                [ngClass]="{
                  'tipoSalida-Privado':
                    bibliaActivityRow.tipoSalida === 'Privado',
                  'tipoSalida-SalidaFija':
                    bibliaActivityRow.tipoSalida === 'Salida Fija',
                  'tipoSalida-Serie': bibliaActivityRow.tipoSalida === 'Serie'
                }"
                class="tipoSalida-item"
              >
                {{ bibliaActivityRow.tipoSalida
                }}{{
                  bibliaActivityRow.tipoSalida === "Salida Fija" &&
                  bibliaActivityRow.fileNumberPadre
                    ? " (" + bibliaActivityRow.fileNumberPadre + ")"
                    : ""
                }}
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nombreItinerario">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
              >Nombre de File</mat-header-cell
            >
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <span
                class="biblia-cell-text"
                [title]="bibliaActivityRow.nombreItinerario"
              >
                {{ bibliaActivityRow.nombreItinerario }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="fileDisplayState">
            <mat-header-cell
              *matHeaderCellDef
              class="headerStyleMedium mat-column-fileDisplayState"
            >
              Status
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium mat-column-fileDisplayState"
            >
              <div
                class="fileDisplayState-pill"
                [ngClass]="{
                  'fileDisplayState-Nuevo':
                    bibliaActivityRow.fileDisplayState === 'NUEVO PEDIDO',
                  'fileDisplayState-Proceso':
                    bibliaActivityRow.fileDisplayState === 'EN PROCESO',
                  'fileDisplayState-Confirmado':
                    bibliaActivityRow.fileDisplayState === 'CONFIRMADO',
                  'fileDisplayState-Reconfirmado':
                    bibliaActivityRow.fileDisplayState === 'RECONFIRMADO',
                  'fileDisplayState-default':
                    !bibliaActivityRow.fileDisplayState ||
                    (bibliaActivityRow.fileDisplayState !== 'NUEVO PEDIDO' &&
                      bibliaActivityRow.fileDisplayState !== 'EN PROCESO' &&
                      bibliaActivityRow.fileDisplayState !== 'CONFIRMADO' &&
                      bibliaActivityRow.fileDisplayState !== 'RECONFIRMADO')
                }"
              >
                {{ bibliaActivityRow?.fileDisplayState || "-" }}
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="paxQuantity">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Pax
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div class="columnPassenger columnPassenger--pax">
                <button
                  type="button"
                  mat-icon-button
                  class="pax-trigger-button"
                  (click)="
                    openDialogPasajeros(bibliaActivityRow.lstPaXByActivity)
                  "
                  matTooltip="Ver lista completa de pasajeros (PAX / TC)"
                >
                  <mat-icon
                    matBadge="{{ bibliaActivityRow.lstPaXByActivity?.length }}"
                    [ngStyle]="{
                      color: hasMinors(bibliaActivityRow.lstPaXByActivity)
                        ? '#0284c7'
                        : '#e95a1a'
                    }"
                  >
                    groups_2
                  </mat-icon>
                </button>

                <div
                  *ngIf="
                    bibliaActivityRow.expanded &&
                    bibliaActivityRow.lstPaXByActivity?.length
                  "
                  class="divPassenger pax-preview-list"
                >
                  <div
                    *ngFor="
                      let pax of getSortedPaxList(
                        bibliaActivityRow.lstPaXByActivity
                      );
                      let i = index
                    "
                    class="pax-preview-item"
                    [class.pax-is-tc]="isPassengerTC(pax)"
                  >
                    <span class="pax-index">{{ i + 1 }}</span>
                    <span
                      class="pax-preview-name"
                      [title]="getPassengerDisplayName(pax)"
                    >
                      {{ formatPassengerName(pax) }}
                    </span>
                    <span
                      *ngIf="isPassengerTC(pax)"
                      class="pax-tc-badge"
                      title="Tour Conductor"
                      >TC</span
                    >
                    <span
                      *ngIf="isPassengerMinor(pax)"
                      class="pax-minor-badge"
                      title="Menor de edad"
                      >&lt;18</span
                    >
                  </div>
                </div>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="numero-pasajeros">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Total N° de Pasajeros
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div class="divPassenger">
                <p>Pasajeros: {{ bibliaActivityRow?.paxCount || 0 }}</p>
                <p>TC: {{ bibliaActivityRow?.tcCount || 0 }}</p>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="agencia">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Agencia
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <span
                class="biblia-cell-text"
                [title]="bibliaActivityRow.agencia"
              >
                {{ bibliaActivityRow.agencia }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="pickUp">
            <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
              Pick Up
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleLarge"
            >
              <div class="biblia-cell-content-edit">
                <i-tabler
                  *ngIf="
                    bibliaActivityRow.upgradeServiceTypes?.includes(
                      'ALOJAMIENTO'
                    )
                  "
                  name="diamond"
                  class="diamond-upgrade"
                ></i-tabler>
                <span
                  class="biblia-cell-text"
                  [title]="getPickUp(bibliaActivityRow)"
                >
                  {{ getPickUp(bibliaActivityRow) }}
                </span>
                <mat-icon
                  class="icon-color icon-edit edit-action-icon"
                  (click)="
                    openDialogEdit(
                      'pickUp',
                      getPickUp(bibliaActivityRow),
                      bibliaActivityRow
                    )
                  "
                  >edit</mat-icon
                >
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="servicio">
            <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
              Servicio
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleLarge"
            >
              <span
                class="biblia-cell-text"
                [title]="bibliaActivityRow.dayName"
              >
                {{ bibliaActivityRow.dayName }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dropOff">
            <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
              Drop Off
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleLarge"
            >
              <div class="biblia-cell-content-edit">
                <i-tabler
                  *ngIf="
                    bibliaActivityRow.upgradeServiceTypes?.includes(
                      'ALOJAMIENTO'
                    )
                  "
                  name="diamond"
                  class="diamond-upgrade"
                ></i-tabler>
                <span
                  class="biblia-cell-text"
                  [title]="getDropOff(bibliaActivityRow)"
                >
                  {{ getDropOff(bibliaActivityRow) }}
                </span>
                <mat-icon
                  class="icon-color icon-edit edit-action-icon"
                  (click)="
                    openDialogEdit(
                      'dropOff',
                      getDropOff(bibliaActivityRow),
                      bibliaActivityRow
                    )
                  "
                  >edit</mat-icon
                >
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="coordinador">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Coordinador
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div
                *ngIf="
                  bibliaActivityRow.serviciosCoordinador?.length;
                  else messageCoordinadorEmpty
                "
              >
                <div
                  *ngFor="let service of bibliaActivityRow.serviciosCoordinador"
                >
                  {{ service.objProvider?.nombre }}
                </div>
              </div>

              <ng-template #messageCoordinadorEmpty>
                <div>NO</div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="guide">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Guia
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div
                *ngIf="
                  bibliaActivityRow.serviciosGuia?.length > 0;
                  else messageGuiaEmpty
                "
              >
                <div
                  *ngFor="
                    let guidanceService of bibliaActivityRow.serviciosGuia
                  "
                  style="display: flex; flex-direction: column"
                >
                  <span>
                    {{ guidanceService.objProvider?.nombre }}
                  </span>
                  <span
                    class="badge-tercerizado"
                    *ngIf="guidanceService.tipoServicio === 'OPERADOR'"
                  >
                    <i-tabler
                      name="tag-starred"
                      style="width: 12px; height: 12px"
                    ></i-tabler>
                    Producto Tercerizado
                  </span>
                </div>
              </div>
              <ng-template #messageGuiaEmpty>
                <div>NO</div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="transport" class="container">
            <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
              Transporte</mat-header-cell
            >

            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleLarge"
            >
              <div
                *ngIf="
                  bibliaActivityRow.serviciosTransporte?.length > 0;
                  else messageTransporteEmpty
                "
              >
                <div
                  *ngFor="let service of bibliaActivityRow.serviciosTransporte"
                >
                  * {{ service.objProvider?.nombre }}/
                  {{ service.categoriaServicio }}
                </div>
              </div>

              <ng-template #messageTransporteEmpty>
                <div>NO</div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="tipoUnidad" class="container">
            <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
              Tipo de Unidad</mat-header-cell
            >
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleLarge"
            >
              <div
                *ngIf="
                  bibliaActivityRow.serviciosTransporte?.length > 0;
                  else messageTransporteEmpty
                "
              >
                <div
                  class="tipo-unidad-by-service"
                  *ngFor="
                    let service of bibliaActivityRow.serviciosTransporte;
                    let i = index
                  "
                >
                  <div class="tipo-unidad-service-title">
                    {{ service.objProvider?.nombre || "Servicio " + (i + 1) }}
                    <span *ngIf="service.categoriaServicio">
                      - {{ service.categoriaServicio }}
                    </span>
                  </div>

                  <div
                    class="tipo-unidad-chip-wrap"
                    *ngIf="service?.tipoDeUnidad?.length; else noTipoUnidadMain"
                  >
                    <span
                      class="tipo-unidad-chip"
                      *ngFor="
                        let unidad of service.tipoDeUnidad.join
                          ? service.tipoDeUnidad
                          : [service.tipoDeUnidad]
                      "
                    >
                      {{ unidad }}
                    </span>
                  </div>

                  <ng-template #noTipoUnidadMain>
                    <span class="tipo-unidad-empty">Sin tipo de unidad</span>
                  </ng-template>
                </div>
                <i-tabler
                  name="car"
                  style="width: 20px; height: 20px; font-size: 20px"
                  class="icon-Dective"
                  (click)="
                    openDialogListServices(bibliaActivityRow, 'TIPODEUNIDAD')
                  "
                ></i-tabler>
              </div>

              <ng-template #messageTransporteEmpty>
                <div>NO</div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="driver">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Driver
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div class="driver-cell-content">
                <span
                  class="driver-cell-value"
                  [title]="bibliaActivityRow.driver"
                >
                  {{ bibliaActivityRow.driver || "NO" }}
                </span>

                <mat-icon
                  class="icon-color icon-edit driver-edit-icon"
                  (click)="
                    openDialogEdit(
                      'driver',
                      bibliaActivityRow.driver,
                      bibliaActivityRow
                    )
                  "
                  >edit</mat-icon
                >
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="meal">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Meals
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <ng-container
                *ngIf="
                  bibliaActivityRow.serviciosMeals?.length;
                  else withoutMeals
                "
              >
                <!-- EXPANDED STATE -->
                <div
                  *ngIf="bibliaActivityRow.expanded"
                  class="divPassenger meals-preview-list"
                >
                  <div
                    *ngFor="let mealService of bibliaActivityRow.serviciosMeals"
                    class="meal-preview-item"
                  >
                    <div class="meal-item-header">
                      <i-tabler
                        *ngIf="
                          bibliaActivityRow.upgradeServiceTypes?.includes(
                            'ALIMENTOSYBEBIDAS'
                          )
                        "
                        name="diamond"
                        class="diamond-upgrade"
                        matTooltip="Servicio Upgrade"
                      ></i-tabler>
                      <span class="meal-service-name">{{
                        mealService.nombreServicio
                      }}</span>
                    </div>

                    <div
                      class="meal-provider-name"
                      *ngIf="mealService.objProvider?.nombre"
                    >
                      {{ mealService.objProvider?.nombre }}
                    </div>

                    <div
                      class="meal-item-obs"
                      *ngIf="mealService.observaciones"
                    >
                      <span class="obs-tag">Obs:</span>
                      <span class="obs-body">{{
                        mealService.observaciones
                      }}</span>
                    </div>
                  </div>
                </div>

                <!-- COLLAPSED STATE -->
                <div
                  *ngIf="!bibliaActivityRow.expanded"
                  class="meal-collapsed-wrap"
                >
                  <i-tabler
                    *ngIf="
                      bibliaActivityRow.upgradeServiceTypes?.includes(
                        'ALIMENTOSYBEBIDAS'
                      )
                    "
                    name="diamond"
                    class="diamond-upgrade"
                    matTooltip="Servicio Upgrade"
                  ></i-tabler>
                  <span class="meal-collapsed-badge">SI +</span>
                </div>
              </ng-container>

              <ng-template #withoutMeals>
                <div class="meal-empty-text">NO</div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="snack">
            <mat-header-cell *matHeaderCellDef class="headerStyle">
              Snacks
            </mat-header-cell>
            <mat-cell *matCellDef="let bibliaActivityRow" class="bodyStyle">
              <div
                *ngIf="
                  bibliaActivityRow.serviciosSnacks?.length;
                  else withoutSnacks
                "
              >
                <div *ngFor="let service of bibliaActivityRow.serviciosSnacks">
                  {{ service.nombreServicio }}
                </div>
              </div>

              <ng-template #withoutSnacks>
                <div>NO</div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="restriccionesAlimentarias">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Restricciones Alimenticias
            </mat-header-cell>
            <mat-cell
              *matCellDef="let bibliaActivityRow"
              class="bodyStyleMedium"
            >
              <div class="obs-cell-row">
                <button
                  type="button"
                  mat-icon-button
                  class="icon-edit-btn"
                  (click)="
                    openDialogListServices(bibliaActivityRow, 'RESTRICCIONES')
                  "
                  matTooltip="Editar restricciones alimenticias"
                >
                  <mat-icon class="icon-color icon-edit">edit</mat-icon>
                </button>
                <div
                  *ngIf="bibliaActivityRow.expanded"
                  class="divPassenger conditions-preview-list"
                >
                  <ng-container
                    *ngIf="
                      getPaxConditionsList(
                        bibliaActivityRow.lstPaXByActivity,
                        'restriccionesAlimentarias'
                      ) as restrictions
                    "
                  >
                    <div *ngIf="restrictions.length > 0; else noRestrictions">
                      <div
                        *ngFor="let item of restrictions"
                        class="pax-condition-item"
                      >
                        <div class="pax-condition-header">
                          <span class="pax-condition-name">{{
                            item.name
                          }}</span>
                          <span *ngIf="item.isTC" class="pax-tc-badge">TC</span>
                        </div>
                        <div class="pax-condition-text">{{ item.detail }}</div>
                      </div>
                    </div>
                    <ng-template #noRestrictions>
                      <div class="pax-condition-empty">Sin restricciones</div>
                    </ng-template>
                  </ng-container>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="condicionesMedicas">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Condiciones Médicas
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyleMedium">
              <div class="obs-cell-row">
                <button
                  type="button"
                  mat-icon-button
                  class="icon-edit-btn"
                  (click)="openDialogListServices(row, 'CONDICIONESMEDICAS')"
                  matTooltip="Editar condiciones médicas"
                >
                  <mat-icon class="icon-color icon-edit">edit</mat-icon>
                </button>
                <div
                  *ngIf="row.expanded"
                  class="divPassenger conditions-preview-list"
                >
                  <ng-container
                    *ngIf="
                      getPaxConditionsList(
                        row.lstPaXByActivity,
                        'condicionesMedicas'
                      ) as conditions
                    "
                  >
                    <div *ngIf="conditions.length > 0; else noConditions">
                      <div
                        *ngFor="let item of conditions"
                        class="pax-condition-item"
                      >
                        <div class="pax-condition-header">
                          <span class="pax-condition-name">{{
                            item.name
                          }}</span>
                          <span *ngIf="item.isTC" class="pax-tc-badge">TC</span>
                        </div>
                        <div class="pax-condition-text">{{ item.detail }}</div>
                      </div>
                    </div>
                    <ng-template #noConditions>
                      <div class="pax-condition-empty">Sin condiciones</div>
                    </ng-template>
                  </ng-container>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="alergias">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Alergias
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyleMedium">
              <div class="obs-cell-row">
                <button
                  type="button"
                  mat-icon-button
                  class="icon-edit-btn"
                  (click)="openDialogListServices(row, 'ALERGIAS')"
                  matTooltip="Editar alergias"
                >
                  <mat-icon class="icon-color icon-edit">edit</mat-icon>
                </button>
                <div
                  *ngIf="row.expanded"
                  class="divPassenger conditions-preview-list"
                >
                  <ng-container
                    *ngIf="
                      getPaxConditionsList(
                        row.lstPaXByActivity,
                        'alergias'
                      ) as allergies
                    "
                  >
                    <div *ngIf="allergies.length > 0; else noAllergies">
                      <div
                        *ngFor="let item of allergies"
                        class="pax-condition-item"
                      >
                        <div class="pax-condition-header">
                          <span class="pax-condition-name">{{
                            item.name
                          }}</span>
                          <span *ngIf="item.isTC" class="pax-tc-badge">TC</span>
                        </div>
                        <div class="pax-condition-text">{{ item.detail }}</div>
                      </div>
                    </div>
                    <ng-template #noAllergies>
                      <div class="pax-condition-empty">Sin alergias</div>
                    </ng-template>
                  </ng-container>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="observaciones">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
              Observaciones
            </mat-header-cell>

            <mat-cell *matCellDef="let row" class="bodyStyleMedium">
              <ng-container *ngIf="row.obsActivity?.length > 0; else NOOBS">
                <div class="obs-cell-row">
                  <button
                    type="button"
                    mat-icon-button
                    class="icon-edit-btn"
                    (click)="openDialogListServices(row, 'OBSERVACIONES')"
                    matTooltip="Editar observaciones"
                  >
                    <i-tabler
                      name="message-plus"
                      style="width: 18px; height: 18px"
                      class="icon-Active"
                    ></i-tabler>
                  </button>
                  <div *ngIf="row.expanded" class="divPassenger obs-card-text">
                    <span class="obs-tag">Obs:</span>
                    <span class="obs-body">{{ row.obsActivity }}</span>
                  </div>
                  <div *ngIf="!row.expanded" class="obs-collapsed-badge">
                    SI +
                  </div>
                </div>
              </ng-container>

              <ng-template #NOOBS>
                <div class="obs-cell-row">
                  <button
                    type="button"
                    mat-icon-button
                    class="icon-edit-btn"
                    (click)="openDialogListServices(row, 'OBSERVACIONES')"
                    matTooltip="Agregar observaciones"
                  >
                    <i-tabler
                      name="message-plus"
                      style="width: 18px; height: 18px"
                      class="icon-Dective"
                    ></i-tabler>
                  </button>
                  <div class="obs-empty-text">NO</div>
                </div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="destino">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
              >Ciudad</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="bodyStyleMedium">
              <div
                class="destino-item"
                [ngClass]="{
                  'destino-Huaraz': transformUpperCase(row.destino) == 'HUARAZ',
                  'destino-Cusco': transformUpperCase(row.destino) == 'CUSCO',
                  'destino-Arequipa':
                    transformUpperCase(row.destino) == 'AREQUIPA',
                  'destino-Lima': transformUpperCase(row.destino) == 'LIMA',
                  'destino-Puerto':
                    transformUpperCase(row.destino) == 'PUERTO MALDONADO',
                  'destino-Puno': transformUpperCase(row.destino) == 'PUNO',
                  'destino-Mul':
                    transformUpperCase(row.destino) == 'MULTIDESTINOS'
                }"
              >
                {{ row?.destino | uppercase }}
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="usuario">
            <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
              Destination Specialist
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyleLarge">
              <span class="biblia-cell-text" [title]="row?.usuario">
                {{ row?.usuario | uppercase }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="operador">
            <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
              Usuario Operador
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyleLarge">
              <span class="biblia-cell-text" [title]="row?.usuarioOperador">
                {{ row?.usuarioOperador | uppercase }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="fechaActualizacionOperacion">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
              >Fecha Actualizacion</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="bodyStyleMedium">
              {{ row.dateActualizacion | date: " dd/MM/yyyy hh:mm:ss" }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="incidencias">
            <mat-header-cell *matHeaderCellDef class="headerStyle">
              Incidencias
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              <mat-icon
                class="icon-color"
                (click)="openDialogListServices(row, 'INCIDENCIAS')"
                >chat_bubble_outline</mat-icon
              >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="historial">
            <mat-header-cell *matHeaderCellDef class="headerStyle">
              Historial
            </mat-header-cell>

            <mat-cell *matCellDef="let row" class="bodyStyle">
              <mat-icon
                style="cursor: pointer"
                class="icon-color"
                (click)="openDialogListhistorial(row, 'HISTORIAL')"
                >history</mat-icon
              >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="revision">
            <mat-header-cell *matHeaderCellDef class="headerStyle">
              Revisión A.C.
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              <div class="columnPassenger">
                <mat-icon
                  (click)="openDialogCsReview(row)"
                  [ngClass]="{
                    approvedIcon: row.pendingCsReviews === false,
                    regularizeIcon: row.pendingCsReviews === true,
                    defaultIcon: row.pendingCsReviews == null
                  }"
                >
                  person
                </mat-icon>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="bibliaDisplayedColumns; sticky: true"
            sticky
          ></mat-header-row>

          <mat-row
            *matRowDef="let row; columns: bibliaDisplayedColumns"
            [ngClass]="getRowClass(row)"
            [class.row-expanded]="row.expanded"
          >
          </mat-row>
        </mat-table>
      </div>

      <mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 20, 50, 100]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>

    <!-- TABLA A EXPORTAR -->

    <mat-table
      [dataSource]="bibliaDataSource"
      matTableExporter
      #exporter="matTableExporter"
      matSort
      style="display: none"
    >
      dateFile
      <ng-container matColumnDef="dateFile">
        <mat-header-cell *matHeaderCellDef class="headerStyle"
          >dateFile</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ row.dateFile }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="restriccionesAlimentarias">
        <mat-header-cell *matHeaderCellDef class="headerStyle"
          >RESTRICCIONES ALIMENTICIAS</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ getFormattedRestriccionesAlimentarias(row.lstPaXByActivity) }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="condicionesMedicas">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          CONDICIONES MÉDICAS</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ getFormattedCondicionesMedicas(row.lstPaXByActivity) }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="alergias">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          ALERGIAS</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ getFormattedAlergias(row.lstPaXByActivity) }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef class="headerStyle"
          >FECHA OPERACIÓN</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ row.date }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nombreItinerario">
        <mat-header-cell *matHeaderCellDef class="headerStyle"
          >NOMBRE FILE</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ row.nombreItinerario }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="horaProgramada">
        <mat-header-cell *matHeaderCellDef class="headerStyle"
          >HORA PROGRAMADA</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyle"
          >{{ row.horaProgramada }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="horaInicioOperacion">
        <mat-header-cell *matHeaderCellDef class="headerStyle dobleHeader"
          >HORA INICIO OPERACION</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyle dobleBody">
          {{ row.horaInicioOperacion }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaActualizacionOperacion">
        <mat-header-cell *matHeaderCellDef class="headerStyle"
          >FECHA ACTUALIZACION</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ row.dateActualizacion }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="vuelos">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
          VUELOS
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyleMedium">
          <div class="divPassenger">
            <div *ngFor="let vuelo of row.vuelos">
              <p *ngIf="isFlightVisible(row, vuelo)">
                <strong>{{ vuelo.airline }} - </strong>
                <strong>{{ vuelo.flightNumber }} - </strong>
                <strong
                  >{{ vuelo.flightCode ? vuelo.flightCode : "N/A" }} -
                </strong>
                <strong
                  >{{
                    vuelo.flightDate
                      ? (vuelo?.flightDate | date: "dd/MM/yyyy")
                      : "N/A"
                  }}
                </strong>
                <br />
                Despegue: {{ formatHoraVuelo(vuelo.departureTime) }}
                <br />
                Arrivo: {{ formatHoraVuelo(vuelo.arrivalTime) }}
              </p>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="trenes">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
          TRENES
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyleMedium">
          <div class="divPassenger">
            <p *ngFor="let tren of row.serviciosMedio">
              [ {{ tren.circuitoTren }} / {{ tren.varianteFrecuencia }} /
              {{ convertirHora12Horas(tren.horario) }} ]
            </p>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipoTarifaAlojamiento">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
          TIPO HABITACIÓN
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyleMedium">
          <div class="divPassenger">
            <p *ngFor="let hotel of row.serviciosAlojamiento">
              [ {{ hotel.paxAlojamiento }} - {{ hotel.tipoTarifaAlojamiento }} ]
            </p>
          </div>
        </mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="medio">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          VUELOS/TREN
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          <div *ngIf="row.serviciosMedio?.length">
            <p *ngFor="let service of row.serviciosMedio">
              {{ service.objProvider.nombre }}
            </p>
          </div>
        </mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="day">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          DAY
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ row.day }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fileNumber">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          FILE
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ row.fileNumber }}{{ row.fileExtend ?? "" }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="agencia">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          AGENCIA
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ row.agencia }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="pickUp">
        <mat-header-cell *matHeaderCellDef class="headerStyle dobleHeader">
          PICK UP
        </mat-header-cell>
        <mat-cell *matCellDef="let bibliaItemRow" class="bodyStyle dobleBody">
          {{ getPickUp(bibliaItemRow) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="servicio">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          SERVICIO
        </mat-header-cell>
        <mat-cell *matCellDef="let bibliaItemRow" class="bodyStyle">
          {{ bibliaItemRow.dayName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dropOff">
        <mat-header-cell *matHeaderCellDef class="headerStyle dobleHeader">
          DROP OFF
        </mat-header-cell>
        <mat-cell *matCellDef="let bibliaItemRow" class="bodyStyle dobleBody">
          {{ getDropOff(bibliaItemRow) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fileDisplayState">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >Status</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="bodyStyleMedium">
          {{ row.fileDisplayState }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="destino">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          CIUDAD
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ row.destino }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipoSalida">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium">
          Tipo Salida
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyleMedium">
          <div
            [ngClass]="{
              'tipoSalida-Privado': row.tipoSalida === 'Privado',
              'tipoSalida-SalidaFija': row.tipoSalida === 'Salida Fija',
              'tipoSalida-Serie': row.tipoSalida === 'Serie'
            }"
            class="tipoSalida-item"
          >
            {{ row.tipoSalida
            }}{{
              row.tipoSalida === "Salida Fija" && row.fileNumberPadre
                ? " (" + row.fileNumberPadre + ")"
                : ""
            }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="equipos">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          equipos
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          <div *ngIf="row.equipo?.length > 0" class="filesHijos-container">
            <span>Equipos:</span>
            <div *ngFor="let file of row.equipo">
              {{ file }}
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="coordinador">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          COORDINADOR
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          <div
            *ngIf="
              row.serviciosCoordinador?.length;
              else messageCoordinadorEmpty
            "
          >
            <p *ngFor="let service of row.serviciosCoordinador">
              {{ service.objProvider?.nombre }}
            </p>
          </div>

          <ng-template #messageCoordinadorEmpty>
            <p>NO</p>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="guide">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          GUIA
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          <div *ngIf="row.serviciosGuia?.length > 0; else messageGuiaEmpty">
            <p *ngFor="let service of row.serviciosGuia">
              {{ service.objProvider?.nombre }}
              <span *ngIf="service.tipoServicio === 'OPERADOR'">
                (Producto Tercerizado)
              </span>
            </p>
          </div>
          <ng-template #messageGuiaEmpty>
            <p>NO</p>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="transport" class="container">
        <mat-header-cell *matHeaderCellDef class="headerStyle tripleHeader">
          TRANSPORTE / CATEGORIA / TIPO</mat-header-cell
        >

        <mat-cell *matCellDef="let row" class="bodyStyle tripleBody">
          <div
            *ngIf="
              row.serviciosTransporte?.length > 0;
              else messageTransporteEmpty
            "
          >
            <div *ngFor="let service of row.serviciosTransporte">
              * {{ service.objProvider?.nombre }} /
              {{ service.categoriaServicio ? service.categoriaServicio : "-" }}
              /
            </div>
          </div>

          <ng-template #messageTransporteEmpty>
            <p>NO</p>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipoUnidad" class="container">
        <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
          Tipo de Unidad</mat-header-cell
        >

        <mat-cell *matCellDef="let row" class="bodyStyleLarge">
          <div
            *ngIf="
              row.serviciosTransporte?.length > 0;
              else messageTransporteEmpty
            "
          >
            <div
              class="tipo-unidad-by-service"
              *ngFor="let service of row.serviciosTransporte; let i = index"
            >
              <div class="tipo-unidad-service-title">
                {{ service.objProvider?.nombre || "Servicio " + (i + 1) }}
                <span *ngIf="service.categoriaServicio">
                  - {{ service.categoriaServicio }}
                </span>
              </div>

              <div
                class="tipo-unidad-chip-wrap"
                *ngIf="
                  service?.tipoDeUnidad?.length;
                  else noTipoUnidadSecondary
                "
              >
                <span
                  class="tipo-unidad-chip"
                  *ngFor="
                    let unidad of service.tipoDeUnidad.join
                      ? service.tipoDeUnidad
                      : [service.tipoDeUnidad]
                  "
                >
                  {{ unidad }}
                </span>
              </div>

              <ng-template #noTipoUnidadSecondary>
                <span class="tipo-unidad-empty">Sin tipo de unidad</span>
              </ng-template>
            </div>
          </div>

          <ng-template #messageTransporteEmpty>
            <div>NO</div>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="driver">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          DRIVER
        </mat-header-cell>
        <mat-cell *matCellDef="let bibliaActivityItem" class="bodyStyle">
          {{ bibliaActivityItem.driver }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="meal">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          MEALS
        </mat-header-cell>
        <mat-cell *matCellDef="let bibliaItem" class="bodyStyle">
          <div *ngIf="bibliaItem.serviciosMeals?.length; else emptyMeals">
            <div class="divPassenger">
              <p
                *ngFor="
                  let meal of bibliaItem.serviciosMeals;
                  let in = index;
                  let last = last
                "
              >
                <strong>{{ meal.nombreServicio }} - </strong>
                {{ meal.objProvider?.nombre }}
                <span *ngIf="meal.observaciones">
                  <br />
                  <em>Obs:</em>
                  {{ meal.observaciones }}
                </span>
                <span *ngIf="!last">; </span>
              </p>
            </div>
          </div>
          <ng-template #emptyMeals>
            <span>NO</span>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="snack">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          SNACKS
        </mat-header-cell>
        <mat-cell *matCellDef="let bibliaItem" class="bodyStyle">
          <div *ngIf="bibliaItem.serviciosSnacks?.length; else withoutSnacks">
            <p *ngFor="let service of bibliaItem.serviciosSnacks">
              {{ service.nombreServicio }}
            </p>
          </div>
          <ng-template #withoutSnacks>
            <p>NO</p>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuario">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          DESTINATION SPECIALIST
        </mat-header-cell>
        <mat-cell *matCellDef="let bibliaItem" class="bodyStyle">
          {{ bibliaItem?.usuario | uppercase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="operador">
        <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
          USUARIO OPERADOR
        </mat-header-cell>
        <mat-cell *matCellDef="let bibliaItem" class="bodyStyleLarge">
          {{ bibliaItem?.usuarioOperador | uppercase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="paxQuantity">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          PAX
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          {{ transformLstPaxToExport(row.lstPaXByActivity) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="numero-pasajeros">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          TOTAL N° PASAJEROS / TC
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          Pasajeros: {{ row?.paxCount || 0 }}, TC:
          {{ row?.tcCount || 0 }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="incidencias">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          INCIDENCIAS
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          <div *ngIf="row.lstServicios?.length">
            <p *ngFor="let service of row.lstServicios">
              {{ service.incidencias ? transform(service.incidencias) : " " }}
            </p>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="observaciones">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          OBSERVACIONES
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          <p>
            {{ row.obsActivity }}
          </p>
          <div *ngIf="row.lstServicios?.length">
            <p *ngFor="let service of row.lstServicios">
              {{
                service.observaciones
                  ? transform(service.observaciones)
                  : "
              "
              }}
            </p>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="historial">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          HISTORIAL
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          <div *ngIf="row.lstServicios?.length">
            <p *ngFor="let service of row.lstServicios">
              {{ service.historial ? transform(service.historial) : " " }}
            </p>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="revision">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Revisión A.C.
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyle">
          <div class="columnPassenger">-</div>
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="bibliaDisplayedColumns"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: bibliaDisplayedColumns"> </mat-row>
    </mat-table>
    <div style="display: flex; justify-content: center; margin: 1rem">
      <button
        mat-raised-button
        class="buttonPrimary"
        (click)="exporter.exportTable('xlsx', { fileName: 'Biblia' })"
      >
        Export Excel
      </button>
    </div>
  </div>
</ng-template>
